import * as React from "react";
import AppConfig from "util/AppConfig";
import { Spinner } from "components/common";
import { IndexSetConfigurationForm } from "components/indices";
import Routes from "routing/Routes";
import { IndexSetsActions } from "stores/indices/IndexSetsStore";
import SelectIndexSetTemplateModal from "components/indices/IndexSetTemplates/SelectIndexSetTemplateModal";
import { adjustFormat } from "util/DateTime";
import useHistory from "routing/useHistory";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import useCurrentUser from "hooks/useCurrentUser";
import { isPermitted } from "util/PermissionsMixin";
import useIndicesConfiguration from "hooks/useIndicesConfiguration";
const CreateIndexSet = ({ showSelectTemplateModal, setShowSelectTemplateModal }) => {
  const isCloud = AppConfig.isCloud();
  const history = useHistory();
  const sendTelemetry = useSendTelemetry();
  const { retentionStrategies, rotationStrategies, retentionStrategiesContext } = useIndicesConfiguration();
  const currentUser = useCurrentUser();
  const _saveConfiguration = (indexSetItem) => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.INDICES.INDEX_SET_CREATED, {
      app_pathname: "indexsets"
    });
    const copy = indexSetItem;
    copy.creation_date = adjustFormat(/* @__PURE__ */ new Date(), "internal");
    return IndexSetsActions.create(copy).then(() => {
      history.push(Routes.SYSTEM.INDICES.LIST);
    });
  };
  const isLoading = () => !rotationStrategies || !retentionStrategies;
  if (isLoading()) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    IndexSetConfigurationForm,
    {
      retentionStrategiesContext,
      rotationStrategies,
      retentionStrategies,
      submitButtonText: "Create index set",
      submitLoadingText: "Creating index set...",
      create: true,
      cancelLink: Routes.SYSTEM.INDICES.LIST,
      onUpdate: _saveConfiguration
    }
  ), !isCloud && isPermitted(currentUser.permissions, "indexset_templates:read") && showSelectTemplateModal && /* @__PURE__ */ React.createElement(
    SelectIndexSetTemplateModal,
    {
      show: showSelectTemplateModal,
      hideModal: () => setShowSelectTemplateModal(false)
    }
  ));
};
export default CreateIndexSet;
